var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-root-node-container"},_vm._l((_vm.field.children),function(child,index){return _c('div',{key:index,staticClass:"survey-root-node-container__field",attrs:{"field":child}},[_c('survey-field',{attrs:{"field":child},on:{"nodeChange":_vm.onNodeChange}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2c7ed2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyRootNode/SurveyRootNode.vue
// module id = null
// module chunks = 